import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const IconDottedLineLg4 = ({ className }) => (
  <svg className={classNames('dotted-line-lg-4 d-none d-lg-block position-absolute', className)} width="243" height="191" viewBox="0 0 243 191" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M241 0.5L238.423 27.9319C235.731 56.579 216.493 80.9863 189.267 90.2957L177.671 94.261C164.27 98.8432 153.631 109.194 148.683 122.464L146.796 127.524C145.94 129.82 144.653 131.932 143.005 133.745V133.745C136.03 141.417 124.23 142.183 116.323 135.476L91 114V114C76.8749 103.112 57.1699 103.17 43.1089 114.14L35.5297 120.054C26.6758 126.962 21.5 137.565 21.5 148.795V171.203C21.5 182.074 11.716 190.33 1 188.5V188.5" stroke="#FDAE39" strokeWidth="4" strokeDasharray="2 2" />
  </svg>
);

IconDottedLineLg4.propTypes = {
  className: PropTypes.string,
};

IconDottedLineLg4.defaultProps = {
  className: '',
};

